import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { OrganizationsService } from 'app/API';
import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';
import { useState } from 'react';

type TProps = {
  organizationId: string;
  userId: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteMemberModal = ({ organizationId, userId, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [error, setError] = useState<string | null>(null);

  const deleteMemberMutation = useMutation({
    mutationFn: () => call(() => OrganizationsService.deleteUser({ oid: organizationId, userId })),
    onMutate: () => {
      setError(null);
    },
    onSuccess: (data) => {
      if (data.error) {
        setError(data.error);
        return;
      }
      onSuccess();
    },
    onError: (mutationError) => {
      setError(mutationError instanceof ApiCallError ? getApiCallErrorMessage(mutationError) : 'Something went wrong.');
    },
  });

  return (
    <ModalWrapper width="390px">
      <ModalTitle>Confirm</ModalTitle>
      {deleteMemberMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="text-center">
        Are you sure you want to delete this member? <br />
        Assigned Jobs will become unassigned.
      </div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button
          onClick={() => deleteMemberMutation.mutate()}
          disabled={deleteMemberMutation.isPending}
          style={{ width: '130px' }}
        >
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
